// Copyright © 2021 Move Closer
import { Domain } from '@service/site';
/**
 * Various configurations connected with the domain topic.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const domain = {
    defaultDomain: Domain.Defence24,
    initialDomain: Domain.Unknown
    // titleRegistry: domainTitleRegistry
};
